import { render, staticRenderFns } from "./AirwayHeatmap.vue?vue&type=template&id=1612f4c6&scoped=true&"
import script from "./AirwayHeatmap.vue?vue&type=script&lang=js&"
export * from "./AirwayHeatmap.vue?vue&type=script&lang=js&"
import style0 from "./AirwayHeatmap.vue?vue&type=style&index=0&id=1612f4c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1612f4c6",
  null
  
)

export default component.exports